const getCanvasProperties = pageNumber => {
  const [pageElement] = global.document.getElementsByClassName(`pdfpage-${pageNumber}`);
  return pageElement ? {
    scale: pageElement['data-scale'],
    offset: pageElement['data-origin'],
    pdfPageHeight: pageElement['data-pdf-page-height'],
    pageHeight: pageElement.height,
    pageWidth: pageElement.width,
    // increasing the pixel density to match device pixelRatio is nice, but causes unnesseary
    // slow down when rendering, was formerly: "global.window.devicePixelRatio || 1"
    dpiScale: 1,
    pageElement
  } : null;
};
export default {
  getCanvasProperties
};